
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Dank Renitenz auf freiem Fuss</h4>
    <p>
  William W. soll weggeschlossen bleiben. Die Staatsanwaltschaft beantragt die Verlängerung der kleinen Verwahrung. Doch
  dagegen wehrt sich der Pädophile ‒ erfolgreich. Mit seinem Anwalt hat er einen Paragraphen gefunden, um frei zu
  kommen: Die stationäre Massnahme dürfe nur verlängert werden, wenn eine gewisse Aussicht auf erfolgreiche Therapie
  besteht. Genau dies sei aber bei seinem Klienten nicht der Fall, argumentiert der Advokat. Und erhält tatsächlich
  recht. «Ohne eine Bereitschaft des Beschwerdeführers, auch die diagnostizierte Pädophilie behandeln zu lassen, sind
  die Erfolgsaussichten zu gering», urteilt das Solothurner Obergericht. Daher sei die kleine Verwahrung aufzuheben. So
  kommt William W. dank seiner Renitenz in Freiheit. Obwohl ein Gutachter die Rückfallgefahr «mittelgradig bis hoch»
  einstuft.
    </p>
    <p>
Immerhin wird eine sogenannte ambulante Massnahme verhängt: Der Freigelassene muss eine Therapie absolvieren. Und der Kanton Solothurn 
hat eine engmaschige Überwachung aufzuziehen, befinden die Richter. Sonst drohen Konsequenzen: Wenn sich der mittlerweile 43-Jährige 
nicht an die Regeln hält, «dürfte wohl nur die nachträgliche Verwahrung bleiben». W. beteuert am Prozessende in seinem Schlusswort, er 
habe gelernt, was es brauche, um nicht mehr straffällig zu werden.
    </p><Image file={require('images/entscheid_obergericht.png')} source='Ausriss aus dem Entscheid des Obergerichts, W. zu entlassen. (RD)' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;